var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tableFiltericon-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3095",
    "data-name": "Rectangle 3095",
    width: 24,
    height: 24,
    transform: "translate(0)",
    fill: "#8a8a8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tableFiltericon",
    transform: "translate(0)",
    clipPath: "url(#tableFiltericon-clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tableSorticon",
    transform: "translate(0 5.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M23.657,8.421H2.005a1.2,1.2,0,0,1,0-2.406H23.657a1.2,1.2,0,0,1,0,2.406Z",
    transform: "translate(-0.831 -6.015)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M19.648,14.034H6.015a1.2,1.2,0,0,1,0-2.406H19.648a1.2,1.2,0,0,1,0,2.406Z",
    transform: "translate(-0.831 -6.015)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M14.836,19.648h-4.01a1.2,1.2,0,0,1,0-2.406h4.01a1.2,1.2,0,0,1,0,2.406Z",
    transform: "translate(-0.831 -6.015)",
    fill: "#8a8a8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFiltericon);
export default __webpack_public_path__ + "static/media/tableFiltericon.12b43e8c03f4c652972e97e66826eb2b.svg";
export { ForwardRef as ReactComponent };